/* ============================================================
   Forestry Pro Supply — Shopify Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // === MOBILE NAV TOGGLE ===
  const mobileToggle = document.querySelector('.fps-mobile-toggle');
  const mobileNav = document.querySelector('.fps-mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      const isOpen = mobileNav.classList.contains('open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // === STICKY HEADER SCROLL ===
  const header = document.querySelector('.fps-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('fps-header-scrolled');
      } else {
        header.classList.remove('fps-header-scrolled');
      }
    });
  }

  // === REVIEW CAROUSEL ===
  const reviewTrack = document.querySelector('.fps-reviews-carousel-track');
  const prevBtn = document.querySelector('.fps-reviews-prev');
  const nextBtn = document.querySelector('.fps-reviews-next');
  const dots = document.querySelectorAll('.fps-reviews-dot');

  if (reviewTrack && prevBtn && nextBtn) {
    let currentIndex = 0;
    const cards = reviewTrack.querySelectorAll('.fps-review-card-full');
    const total = cards.length;

    function updateCarousel() {
      reviewTrack.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    prevBtn.addEventListener('click', function () {
      currentIndex = (currentIndex - 1 + total) % total;
      updateCarousel();
    });

    nextBtn.addEventListener('click', function () {
      currentIndex = (currentIndex + 1) % total;
      updateCarousel();
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', function () {
        currentIndex = i;
        updateCarousel();
      });
    });

    // Auto-advance every 5 seconds
    setInterval(function () {
      currentIndex = (currentIndex + 1) % total;
      updateCarousel();
    }, 5000);
  }

  // === CART DRAWER (Shopify) ===
  const cartBtns = document.querySelectorAll('.fps-cart-btn');
  cartBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Trigger Shopify cart drawer or redirect to cart
      if (typeof Shopify !== 'undefined') {
        window.location.href = '/cart';
      }
    });
  });

  // === FORM SUBMISSION ===
  const contactForm = document.querySelector('.fps-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      // Shopify handles form submission via action attribute
      // This just adds a loading state
      const btn = contactForm.querySelector('[type="submit"]');
      if (btn) {
        btn.textContent = 'Sending...';
        btn.disabled = true;
      }
    });
  }

  // === NEWSLETTER FORM ===
  const newsletterForms = document.querySelectorAll('.fps-newsletter-form');
  newsletterForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
      }
    });
  });

  // === SMOOTH SCROLL FOR ANCHOR LINKS ===
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // === ANNOUNCEMENT BAR DUPLICATE FOR SEAMLESS LOOP ===
  const announcementTrack = document.querySelector('.fps-announcement-track');
  if (announcementTrack) {
    const clone = announcementTrack.innerHTML;
    announcementTrack.innerHTML += clone;
  }

});
